
import { getOrderProcess } from '@/api/templateEvaluate';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

import OrderProcess from './components/systemProcess.vue';

@Component({
  name: 'SystemSettingOrder',
  components: {
    OrderProcess
  }
})
export default class extends Vue {
  // private activeName = 'first'
  private listData: any = { // 此处重点学习 如果不初始Key 组件接收数据为空
    process: {},
    module: [],
    moduleAuth: {},
    moduleAlias: {}
  }
  private selectedData: any = {}
  private visible = false;
  private dataSource: any = {};
  private type = 2;
  // private isNeiBao = false;

  private isHaveRepair=false;
  // private isHaveInstall=false;
  // private isHaveCheck=false;

  // 切换tab点击事件  注意寄修 转派 协同数据的处理
  // private tabClick(tab: any, event: any) {
  //   if (this.activeName === 'first') {
  //     this.listData.process = this.dataSource.level.repair_module.auth;
  //     this.listData.module = this.dataSource.level.repair_module.module;
  //     this.listData.moduleAuth = this.dataSource.level.repair_module.module_auth;
  //     this.listData.moduleAlias = this.dataSource.module_alias;
  //     this.listData.authConfig = this.dataSource.auth_config;
  //     this.selectedData = this.dataSource.repair;
  //     // this.type = 2;
  //     // this.getOrderProcess();
  //   } else if (this.activeName === 'second') {
  //     this.listData.process = this.dataSource.level.install_module.auth;
  //     this.listData.module = this.dataSource.level.install_module.module;
  //     this.listData.moduleAuth = this.dataSource.level.install_module.module_auth;
  //     this.listData.moduleAlias = this.dataSource.module_alias;
  //     this.listData.authConfig = this.dataSource.auth_config;
  //     this.selectedData = this.dataSource.install;
  //     // this.type = 3;
  //     // this.getOrderProcess
  //   } else if (this.activeName === 'third') {
  //     this.listData.process = this.dataSource.level.check_module.auth;
  //     this.listData.module = this.dataSource.level.check_module.module;
  //     this.listData.moduleAuth = this.dataSource.level.check_module.module_auth;
  //     this.listData.moduleAlias = this.dataSource.module_alias;
  //     this.listData.authConfig = this.dataSource.auth_config;
  //     this.selectedData = this.dataSource.check;
  //   } else {
  //     this.listData.process = this.dataSource.level.other_module.auth;
  //     this.listData.module = this.dataSource.level.other_module.module;
  //     this.listData.moduleAuth = this.dataSource.level.other_module.module_auth;
  //     this.listData.moduleAlias = this.dataSource.module_alias;
  //     this.listData.authConfig = this.dataSource.auth_config;
  //     this.selectedData = this.dataSource.other;
  //   }
  // }

  /**
   * 东改 订单设置
  */
  // life circle
  private created() {
    // let vipLevel = (UserModule.getCompany as any).vip_level;
    // this.isNeiBao = vipLevel.substr(0, 1) === '2';
    this.getOrderProcess();
  }
  private getOrderProcess() {
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    getOrderProcess(params).then(res => {
      const data = res.data;
      if (data) {
        this.dataSource = data;
        // if (this.dataSource.level && this.dataSource.level.check_module) {
        //   this.isHaveCheck = true;
        // } else {
        //   this.isHaveCheck = false;
        // }
        if (this.dataSource.level && this.dataSource.level.repair_module) {
          this.isHaveRepair = true;
        } else {
          this.isHaveRepair = false;
        }
        // if (this.dataSource.level && this.dataSource.level.install_module) {
        //   this.isHaveInstall = true;
        // } else {
        //   this.isHaveInstall = false;
        // }
        this.listData.process = data.level.repair_module.auth;
        this.listData.module = data.level.repair_module.module;
        this.listData.moduleAuth = data.level.repair_module.module_auth;
        this.listData.moduleAlias = data.module_alias;
        this.listData.authConfig = data.auth_config;
        this.selectedData = data.repair;
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // hud
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
